module.exports = __webpack_public_path__ + "img/cpr.84fcdd35.png";